import { useNavigate } from "react-router-dom";
import { createPublicCharacter } from "../../../store/character/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { initializeSocket, getSocket } from "../../../helpers/socket";
import React, { useState, useEffect } from "react";
import CompanionLoadingPopup from "../../../components/Modals/CompanionLoadingPopup/index";

const CompanionSelection = () => {
  const navigate = useNavigate();
  const socket = getSocket();
  const dispatch = useDispatch();
  const values = JSON.parse(localStorage.getItem("signupValues"));
  const [createAi, setCreateAi] = useState(false);

  const { user } = useSelector((state) => state.Auth);
  const userId = user?._id || user?.user?._id;
  useEffect(() => {
    if (userId && !socket) {
      initializeSocket(userId);
    }
  }, [userId]);

  const payload = {
    name: values.name || "",
    category: values.category || "",
    gender: values.gender || "",
    style: values.style || "",
    bio: values.bio || "",
    type: "public",
    questions: {
      flirtStyle: values.questions?.flirtStyle?.name || "",
      romanticEnergy: values.questions?.romanticEnergy?.name || "",
      rolePreference:
        typeof values.questions?.rolePreference === "string"
          ? values.questions.rolePreference || ""
          : values.questions?.rolePreference?.name || "",
      emotionalAvailability:
        values.questions?.emotionalAvailability?.name || "",
      topics: values.questions?.Topics?.map((topic) => topic.name) || [],

      emotionalSupport: values.questions?.EmotionalSupport?.name || "",
      toughDayResponse: values.questions?.ToughDayResponse?.name || "",
      expressiveness: values.questions?.Expressiveness?.name || "",
      agreementStyle: values.questions?.AgreementStyle?.name || "",
    },
    personality:
      values.personalities?.map((personality) => personality.name) || [],
    hobby: values.hobby?.map((hobbyItem) => hobbyItem.name) || [],
    age: values.age?.name || "",
    faceShape: values.faceShape?.name || "",
    skinTone: values.skinTone?.name || "",
    hairColor: values.hairColor?.name || "",
    hairLength: values.hairLength?.name || "",
    // hairTexture: values.hairTexture?.name || "",
    hairStyle: values.hairStyle?.name || "",
    eyeColor: values.eyeColor?.name || "",
    bodyType: values.bodyType?.name || "",
    clothingStyle: values.clothingStyle?.name || "",
    tattoos: values.tattoos?.name || "",
    breast: values.breast?.name || "",
    butt: values.butt?.name || "",
  };

  useEffect(() => {
    if (!socket) return;
    socket.on("image_Notification", (data) => {
      console.log("Received Ai notification:", data);
      if (data.status == "success" && data.type == "Character") {
        console.log("stage1");
        localStorage.removeItem("signupValues");
        localStorage.setItem("characterType", data.data.style);
        navigate(`/public-character`);
      } else if (data.status === "success" && data.type === "Tokens") {
        console.log("Updating tokens:", data.data.tokens);
        // dispatch(updateToken(data.data.tokens));
      } else if (data.status == "failed" && data.type == "Character") {
        toast.error("Failed! Please try again!");
        setCreateAi(false);
      }
    });
    return () => {
      socket.off("image_Notification");
    };
  }, [socket]);

  const handleCreateAi = () => {
    setCreateAi(true);
    const callBack = (err, responce) => {
      if (err) {
        setCreateAi(false);
        toast.error(err);
      } else {
        console.log(responce, "teststs");
      }
    };

    dispatch(
      createPublicCharacter({
        data: payload,
        callBack: callBack,
      })
    );
  };

  // Define the order for physical appearance fields (image-related data)
  const physicalAppearanceOrder = [
    "gender",
    "style",
    "age",
    "faceShape",
    "skinTone",
    "hairColor",
    "hairLength",
    "beardType",
    // "hairTexture",
    "hairStyle",
    "eyeColor",
    "bodyType",
    "bodyHair",
    "clothingStyle",
    "tattoos",
    "breast",
    "butt",
    "penis",
  ];

  const renderQuestionsData = () => {
    if (!values?.questions) return null;

    const items = [];

    // Handle individual question objects and strings (excluding topics as it's handled separately)
    Object.entries(values.questions).forEach(([key, value]) => {
      if (key !== "Topics" && value) {
        let displayText = "";

        // Handle object values with name/title properties
        if (typeof value === "object" && !Array.isArray(value) && value.name) {
          displayText = value.title?.title || value.name;
        }
        // Handle string values (custom input text)
        else if (typeof value === "string" && value.trim() !== "") {
          displayText = value;
        }
        // Handle other object structures that might not have 'name' but have displayable content
        else if (typeof value === "object" && !Array.isArray(value)) {
          displayText = value.title?.title || value.label || value.text || "";
        }

        // Only render if we have displayable text
        if (displayText) {
          items.push(
            <div key={key} className="col-md-3 col-sm-6 my-2">
              <div className="p-3 text-center border border-[#C9C9C9] rounded">
                <p className="m-0 font-playfair text-[#1C1C1E]">
                  {displayText}
                </p>
              </div>
            </div>
          );
        }
      }
    });

    // Handle topics array separately
    if (values.questions.Topics && Array.isArray(values.questions.Topics)) {
      values.questions.Topics.forEach((topic, index) => {
        if (topic && (topic.name || topic.title?.title)) {
          items.push(
            <div key={`topic-${index}`} className="col-md-3 col-sm-6 col-lg-12">
              <div className="p-3 h-100 text-center border border-[#C9C9C9]">
                <p className="m-0 font-playfair text-[#1C1C1E]">
                  {topic.title?.title || topic.name}
                </p>
              </div>
            </div>
          );
        }
      });
    }

    return items;
  };

  const renderPhysicalAppearanceData = () => {
    const items = [];

    // Helper function to get default image based on style and gender
    const getDefaultImage = (field) => {
      const gender = values?.gender || "female";
      const style = values?.style || "Realistic";

      // For style field, use the style value itself to determine image
      if (field === "style") {
        const value = values?.[field];
        if (value === "Realistic") {
          return gender === "male"
            ? "/assets/media/male-relastic.jpg"
            : "/assets/media/girls.png";
        } else if (value === "Anime") {
          return gender === "male"
            ? "/assets/media/male-anime.png"
            : "/assets/media/anime.png";
        }
      }

      // For all other fields, use current style and gender to determine default image
      if (style === "Realistic") {
        return gender === "male"
          ? "/assets/media/male-relastic.jpg"
          : "/assets/media/female.png";
      } else if (style === "Anime") {
        return gender === "male"
          ? "/assets/media/male-anime.png"
          : "/assets/media/anime.png";
      }

      // Fallback
      return "/assets/media/female.png";
    };

    physicalAppearanceOrder.forEach((field) => {
      const value = values?.[field];
      if (value) {
        const displayValue =
          typeof value === "object" ? value.title?.title || value.name : value;

        // Use provided image or get default based on style and gender
        const imageSrc =
          typeof value === "object" && value.image
            ? value.image
            : getDefaultImage(field);

        items.push(
          <div key={field} className="col-md-3 col-sm-6 my-2">
            <div className="aspect-square rounded text-center p-5 border border-[#C9C9C9] d-flex align-items-center justify-content-center flex-column">
              <img
                src={imageSrc}
                // height={10000}
                // width={10000}
                alt=""
                className="max-w-full mx-auto h-[140px] w-[140px] rounded-circle object-fit-cover mb-5"
              />
              <p className="m-0 font-playfair text-[16px] text-[#1C1C1E]">
                {displayValue}
              </p>
            </div>
          </div>
        );
      }
    });

    return items;
  };

  // Render hobby and personality data (last section without images)
  const renderHobbyPersonalityData = () => {
    const items = [];

    // Render personalities
    if (values?.personalities && Array.isArray(values.personalities)) {
      values.personalities.forEach((personality, index) => {
        items.push(
          <div key={`personality-${index}`} className="col-md-3 col-sm-6 my-2">
            <div className="p-3 h-100 text-center border border-[#C9C9C9] rounded-[30px] rounded">
              <p className="m-0 font-playfair text-[#1C1C1E]">
                {personality.title?.title || personality.name}
              </p>
            </div>
          </div>
        );
      });
    }

    // Render hobbies
    if (values?.hobby && Array.isArray(values.hobby)) {
      values.hobby.forEach((hobbyItem, index) => {
        items.push(
          <div key={`hobby-${index}`} className="col-md-3 col-sm-6 my-2">
            <div className="p-3 h-100 text-center border border-[#C9C9C9] rounded-[30px] rounded">
              <p className="m-0 font-playfair text-[#1C1C1E]">
                {hobbyItem.title?.title || hobbyItem.name}
              </p>
            </div>
          </div>
        );
      });
    }

    return items;
  };

  // Left icon placeholder (you'll need to define this)
  const leftIcn = <span>←</span>; // Replace with your actual icon

  return (
    <>
      <CompanionLoadingPopup createAi={createAi} setCreateAi={setCreateAi} />,
      <section className="py-10 relative">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 py-3">
              <div className="text-center relative d-flex align-items-center justify-content-center gap-4">
                <span className="icn">{leftIcn}</span>
                <h4 className="m-0 text-[#1F2B3B] text-[24px]">
                  Companion Selections
                </h4>
                <span className="icn">{leftIcn}</span>
              </div>
            </div>

            {/* Display name if available */}
            {values?.name && (
              <div className="col-lg-12 py-2">
                <div className="text-center">
                  <h5 className="m-0 text-[#1F2B3B] text-[20px] font-playfair">
                    {values.name}
                  </h5>
                </div>
              </div>
            )}

            <div className="col-lg-12 py-3">
              <div className="text-center">
                <button
                  // onClick={() => router.push("/auth/gallery")}
                  onClick={handleCreateAi}
                  className="d-inline-flex text-white align-items-center justify-content-center rounded-pill px-8 font-semibold commonBtn btn text-[16px] bg-[#BF4AA2] h-[46px] font-playfair"
                >
                  Awaken your companion
                </button>
              </div>
            </div>

            <div className="col-lg-12 py-3">
              <div className="row mt-[50px]">
                <div className="col-md-12 my-3 pb-4">
                  <h5 className=" text-center text-[#1F2B3B] text-[24px] pb-3 mb-3 border-bottom">
                    Emotional Needs
                  </h5>
                  <div className="row">{renderQuestionsData()}</div>
                </div>
                <div className="col-lg-12 my-3 pb-4">
                  <h5 className=" text-center text-[#1F2B3B] text-[24px] pb-3 mb-3 border-bottom">
                    Visual + Physical Customization
                  </h5>
                  <div className="row mt-[50px]">
                    {renderPhysicalAppearanceData()}
                  </div>
                </div>
                <div className="col-lg-12 my-3 pb-4">
                  <h5 className=" text-center text-[#1F2B3B] text-[24px] pb-3 mb-3 border-bottom">
                    Personality & Hobbies
                  </h5>
                  <div className="row">{renderHobbyPersonalityData()}</div>
                </div>
                <div className="col-lg-12 my-3 pb-4">
                  <h5 className=" text-center text-[#1F2B3B] text-[24px] pb-3 mb-3 border-bottom">
                    Bio
                  </h5>
                  <div className="row">
                    {values?.bio && (
                      <div className="col-lg-12 py-2">
                        <div className="text-center">
                          <p className="m-0 text-[#1F2B3B] text-[20px] font-playfair ">
                            {values.bio}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CompanionSelection;
